import React, { Fragment, useEffect, useState } from "react";
import Header from "../../components/Header";
import Checkbox from "./components/Checkbox";
import Firebase from "../../firebasehelper";
import { populateMissingTabs } from "../../Utils/utils";
import { CRM_TABS } from "./constants";
import { useLocation, useHistory } from "react-router-dom/cjs/react-router-dom";
import "./index.css";

export default function BespokeCRMTabs() {
  const [brandData, setBrandData] = useState({});
  const [crmTabs, setCRMTabs] = useState({});
  const [isLoading, setLoading] = useState(true);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (!location.state) history.push("/");
    else {
      const { brand } = location.state;
      Firebase.getBrandDataByID(brand, (brandDataResponse) => {
        if (brandDataResponse) {
          const { crmTabs, ...rest } = brandDataResponse;
          setBrandData(rest);

          // Note: We use this code to fill in any crm tabs that are missing
          // from brands created before 15th Feb 2024 to avoid unexpected behavior
          const updatedTabs = populateMissingTabs(crmTabs);
          setCRMTabs(updatedTabs);
        }
        setLoading(false);
      });
    }
  }, []);

  const toggleFeature = async (name, on) => {
    try {
      const { brand: brandId } = location.state;
      const updatedTabs = { ...crmTabs, [name]: on };

      // send update to firestore
      await Firebase.updateBrandDataById(brandId, {
        crmTabs: updatedTabs,
      });

      // update state
      setCRMTabs(updatedTabs);
    } catch (err) {
      console.log("toggleFeature() error", err);
    }
  };

  return isLoading ? (
    <main className="bespoke-tabs__loading">
      <i className="fa fa-3x fa-sync fa-spin text-muted" />
    </main>
  ) : (
    <Fragment>
      <Header
        username={location.state.username}
        role={location.state.role}
        logo={brandData.logo}
        brand={location.state.brand}
        brandName={brandData.name}
      />
      <main className="bespoke-tabs">
        <h1 className="bespoke-tabs__header">{`Bespoke ${brandData.name}'s CRM tabs`}</h1>
        <section className="bespoke-tabs__content">
          <div className="bespoke-tabs__checkbox-container">
            <h2 className="bespoke-tabs__sub-header">CRM tabs</h2>
            {CRM_TABS.map((tab) => (
              <Fragment key={tab}>
                <Checkbox
                  label={tab}
                  checked={crmTabs[tab]}
                  onChange={() => toggleFeature(tab, !crmTabs[tab])}
                  hex={brandData.hex}
                  white={brandData.white}
                />
              </Fragment>
            ))}
          </div>
          <p className="bespoke-tabs__description">{`Use the checkboxes to specify which navigation tabs should be visible to ${brandData.name}'s brand admins on their CRM platform.`}</p>
        </section>
      </main>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/BespokeCRMTabs/index.js